<template>
  <DashboardMenu />
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="h1">Дашборд</h1>
      </div>
    </div>

    <div class="mdc-card">
      <div class="mdc-card-wrapper__text-section">
        <div class="card__title">Данные</div>
        <div class="infographics">
          <div class="report">
            <h4>Отчет за неделю</h4>
            <Bar :chart-data="chartData" />
          </div>
          <div class="report">
            <h4>Типы проверок</h4>
            <Pie :chart-data="chartDataPie" />
          </div>
        </div>
      </div>

      <!-- </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';
import 'chart.js/auto';
import { Bar, Pie } from 'vue-chartjs';
// import {
//   Chart as ChartJS,
//   Title,
//   Tooltip,
//   Legend,
//   BarElement,
//   PieElement,
//   CategoryScale,
//   LinearScale
// } from 'chart.js';

// ChartJS.register(
//   Title,
//   Tooltip,
//   Legend,
//   BarElement,
//   PieElement,
//   CategoryScale,
//   LinearScale
// );

export default {
  data() {
    return {
      totalChecks: 0,
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Аккаунты',
            backgroundColor: '#add8e6',
            data: [2, 3, 12, 1, 1]
          },
          {
            label: 'Запросы',
            backgroundColor: '#f87979',
            data: [2, 3, 12, 1, 1]
          }
        ]
      },
      chartDataPie: {
        labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue'],
        datasets: [
          {
            label: 'Dataset 1',
            data: [1, 2, 3, 4, 5],
            backgroundColor: [
              '#e66a57',
              '#509a55',
              '#9d3c8a',
              '#f1b625',
              '#4fbc31'
            ]
          }
        ]
      }
    };
  },

  computed: {},

  methods: {
    async getWeekStats() {
      try {
        const token = localStorage.getItem('adminAuthToken');

        const resp = await this.axios.get('checks/thisWeek/stats', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(resp);
        const days = [];

        const accountsData = [];
        const checksCounsData = [];

        resp.data.forEach(v => {
          accountsData.push(v.accounts);
          checksCounsData.push(v.count);
          const date = new Date(v.date);
          const day = date.getDate();
          let month = date.getMonth();
          ++month;
          if (month < 10) {
            days.push(`${day}.0${month}`);
          } else {
            days.push(`${day}.${month}`);
          }
        });

        this.chartData.labels = days;
        this.chartData.datasets[0].data = accountsData;
        this.chartData.datasets[1].data = checksCounsData;
        console.log(days);
        // this.totalChecks = resp.data._sum.accounts;
      } catch (err) {
        console.log(err);
      }
    },
    async getWeekTypes() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('checks/thisWeek/types', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(resp);

        const types = [];
        const amounts = [];

        resp.data.forEach(v => {
          amounts.push(v.count);
          types.push(v.type);
        });

        this.chartDataPie.labels = types;
        this.chartDataPie.datasets[0].data = amounts;

        // this.totalChecks = resp.data._sum.accounts;
      } catch (err) {
        console.log(err);
      }
    }
  },

  mounted: function() {
    this.getWeekStats();
    this.getWeekTypes();
  },
  components: { DashboardMenu, Bar, Pie }
};
</script>

<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';
.container {
  flex-direction: column;
}
.infographics {
  display: flex;
  align-items: center;
  .report {
    width: 33%;
  }
}
</style>